import React from 'react';
import {
  Info as InfoIcon,
  CheckCircle as LaunchIcon,
  Warning as DeactivateIcon,
} from '@material-ui/icons';
import Modal from '../../../../Shared/Modal';
import RoundedButton from '../../../../Shared/RoundedButton';
import { statusChangeConfig } from '../constants';

const StatusChangeConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  statusConfirmModal,
  classes,
  currentSurvey,
}) => {
  const getModalConfig = () => {
    const { type, step } = statusConfirmModal;
    if (type === 'archive' && step === 2) {
      return statusChangeConfig.archive.step2;
    } else if (type === 'archive') {
      return statusChangeConfig.archive.step1;
    }
    return statusChangeConfig[type] || {};
  };

  const config = getModalConfig();

  const getModalIcon = () => {
    const { type } = statusConfirmModal;
    switch (type) {
      case 'launch':
      case 'relaunch':
      case 'unarchive':
        return <LaunchIcon className={classes.deleteWarningIcon} style={{ color: '#4caf50' }} />;
      case 'deactivate':
      case 'archive':
        return <DeactivateIcon className={classes.deleteWarningIcon} style={{ color: '#ff9800' }} />;
      default:
        return <InfoIcon className={classes.deleteWarningIcon} style={{ color: '#2196f3' }} />;
    }
  };

  return (
    <Modal
      open={open}
      classes={{ paper: classes.deleteModal }}
      title={config.title || 'Confirm Action'}
      handleClose={onClose}
    >
      <div className={classes.deleteModalContent}>
        {getModalIcon()}
        <h2 className={classes.deleteModalTitle}>
          {config.message}
        </h2>
        <p className={classes.deleteModalMessage}>
          {config.description}
        </p>
        {currentSurvey?.title && (
          <p className={classes.deleteModalMessage}>
            Assessment: <span className={classes.surveyNameHighlight}>"{currentSurvey.title}"</span>
          </p>
        )}
      </div>

      <div className={classes.deleteModalActions}>
        <RoundedButton
          variant="outlined"
          color="primary"
          size="medium"
          onClick={onClose}
          disabled={statusConfirmModal.loading}
          className={classes.deleteModalButton}
        >
          Cancel
        </RoundedButton>
        <RoundedButton
          variant="contained"
          size="medium"
          onClick={onConfirm}
          isLoading={statusConfirmModal.loading}
          className={`${classes.deleteModalButton} ${classes[config.confirmButtonClass] || ''}`}
        >
          {config.confirmText || 'Confirm'}
        </RoundedButton>
      </div>
    </Modal>
  );
};

export default StatusChangeConfirmationModal;